import React from 'react';
import {Box, css} from '@dna/react';

export const ResidentPagerContainer = (props:{children?:JSX.Element}) => {
    

    return <div className={css({
                display:"flex",
                flexDirection:"row-reverse"
            })}>
                <Box css={{
                    marginTop:"small",
                    marginBottom:"small",
                    marginEnd:"small"
                }}>
                    {props.children}
                </Box>
        </div>
    
}